(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["bsl-cwl-promise-card"] && !Shopify.designMode) return;
  try {
    (function () {
  function central() {
    var q = new URLSearchParams(location.search).get('cwl_today');
    var s = q && /^\d{4}-\d{2}-\d{2}$/.test(q) ? q : new Intl.DateTimeFormat('en-CA', { timeZone: 'America/Chicago' }).format(new Date());
    var p = s.split('-').map(Number);
    return Date.UTC(p[0], p[1] - 1, p[2]);
  }
  function mmdd(y, v) { var p = v.split('-').map(Number); return Date.UTC(y, p[0] - 1, p[1]); }
  function run(root) {
    root.querySelectorAll('[data-cwp-ship]').forEach(function (el) {
      try {
        var today = central();
        var y = new Date(today).getUTCFullYear();
        var end = mmdd(y, el.dataset.deadline), start = mmdd(y, el.dataset.from);
        if (today < start || today > end) { el.hidden = true; return; }
        var d = Math.round((end - today) / 86400000);
        var days = d === 0 ? 'Last day' : d === 1 ? '1 day left' : d + ' days left';
        el.textContent = el.dataset.text.replace('{date}', el.dataset.dateLabel).replace('{days}', days);
        el.hidden = false;
      } catch (e) { el.hidden = true; }
    });
  }
  run(document);
  document.addEventListener('shopify:section:load', function (e) { run(e.target); });
})();
  } catch(e) { console.error(e); }
})();

})();
